import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=4d578840&lang=scss&scoped=true"

import exportComponent from "D:\\zwy\\sdt\\云服务器租赁\\node_modules\\_vue-loader@17.0.1@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d578840"]])

export default __exports__